/**
 * 支払い情報(口座・現金・カード)の表記(2026-09-08 発注者指示)。
 * どの画面でも「会社名: 口座名」でそろえる。例: 「SUM: 楽天銀行」「KMA: AMEXカード」「SUM: 現金」
 * カードは名前の後ろに「カード」を付ける(すでに付いていればそのまま)。
 */
import type { CashAccount } from './types';

export function formatCashAccountLabel(
  a: Pick<CashAccount, 'name' | 'kind'>,
  companyLabel: string | null | undefined,
): string {
  const base = a.name.trim();
  const name = a.kind === 'card' && !/カード$/.test(base) ? `${base}カード` : base;
  return companyLabel ? `${companyLabel}: ${name}` : name;
}
